import { renderLiquid } from "lopermut"
import z from "zod"
import { Errors } from "../../errors"

export const ZendeskIntegrationResponseDataSchema = z
  .object({
    maskedToken: z.string(),
    email: z.string(),
    companySubdomain: z.string(),
  })
  .nullish()

export const UpsertZendeskIntegrationResponseDataSchema = z.object({
  maskedToken: z.string(),
  email: z.string(),
})

export const ZendeskPriorityEnum = {
  low: "low",
  medium: "medium",
  high: "high",
  urgent: "urgent",
} as const

export const CreateZendeskTicketConfigSchema = z.object({
  subject: z.string().min(1, { message: Errors.ZENDESK_SUBJECT_TITLE_REQUIRED }),
  comment: z
    .string()
    .transform((el) => (el && el.trim().length > 0 ? el : null))
    .nullish(),
  brandId: z
    .string()
    .transform((el) => (el && el.trim().length > 0 ? el : null))
    .nullish(),
  ticketFormId: z
    .string()
    .transform((el) => (el && el.trim().length > 0 ? el : null))
    .nullish(),
  customFields: z
    .string()
    .transform((el) => {
      if (!el || el.trim().length === 0) return null
      return el
    })
    .nullish()
    .refine(
      (val) => {
        if (!val) return true
        try {
          JSON.parse(renderLiquid(val, {}))
          return true
        } catch {
          return false
        }
      },
      { message: Errors.INVALID_JSON },
    ),
  tags: z
    .string()
    .transform((el) => (el && el.trim().length > 0 ? el : null))
    .nullish(),
  priority: z.nativeEnum(ZendeskPriorityEnum).nullish(),
})

export const TestZendeskIntegrationResponseDataSchema = z.object({
  data: CreateZendeskTicketConfigSchema,
  eventPayload: z.record(z.string(), z.any()),
})

const ZendeskAuditValueSchema = z.unknown().nullable()

export const ZendeskTicketAuditsResponseDataSchema = z.object({
  ticket: z.object({
    tags: z.array(z.string()),
    status: z.string().nullable(),
    archived: z.boolean(),
  }),
  audits: z.array(
    z.object({
      id: z.string(),
      createdAt: z.string(),
      via: z.string().nullable(),
      events: z.array(
        z.object({
          type: z.string(),
          fieldName: z.string().nullable(),
          value: ZendeskAuditValueSchema,
          previousValue: ZendeskAuditValueSchema,
          public: z.boolean().nullable(),
          body: z.string().nullable(),
          attachmentsCount: z.number(),
        }),
      ),
    }),
  ),
})
